import React from 'react';

import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import SpeakerNotesOffIcon from '@mui/icons-material/SpeakerNotesOff';

const ActivityReviewStatusIcon = ({status, isRequired}) => {

    let icon = <SpeakerNotesIcon color={isRequired ? 'warning' : 'default' } />

    switch (status) {

        case 'completed':
            icon = <SpeakerNotesIcon color={'success'} />
            break

        case 'deferred':
            icon = <SpeakerNotesIcon color={isRequired ? 'warning' : 'default' } />
            break

        case 'n/a':
            icon = <SpeakerNotesOffIcon color={isRequired ? 'warning' : 'default' } />
            break

        default:
            break
    }

    return icon;
};

export default ActivityReviewStatusIcon;
